import { Card, Skeleton, Box } from '@mui/material';

/**
 * Drop-in placeholder for KpiCard during initial data fetch.
 *
 * Mirrors KpiCard's layout (rounded icon tile on the left, label above value)
 * with MUI Skeleton so grid dimensions are stable when real data arrives —
 * preventing layout shift. Keep the two in step: if KpiCard's padding or icon
 * tile size changes, change it here too.
 */
export default function KpiCardSkeleton() {
  return (
    <Card sx={{ height: '100%', display: 'flex' }} aria-hidden="true">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 1.875,
          py: 1.75,
          width: '100%',
        }}
      >
        {/* Icon tile — 38px rounded square, matching KpiCard's tinted tile */}
        <Skeleton
          variant="rectangular"
          width={38}
          height={38}
          sx={{ borderRadius: '11px', flex: 'none' }}
        />

        <Box sx={{ flex: 1, minWidth: 0 }}>
          {/* Label slot — matches KpiCard's 11px eyebrow */}
          <Skeleton variant="text" width="60%" sx={{ fontSize: '0.6875rem' }} />
          {/* Value slot — matches KpiCard's 23px tabular number */}
          <Skeleton variant="text" width="35%" sx={{ fontSize: '1.4375rem' }} />
        </Box>
      </Box>
    </Card>
  );
}
